import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Define the translation resources directly to avoid JSON import issues
const resources = {
  'en-US': {
    common: {
      "app": {
        "title": "GlitchAds",
        "menu": {
          "home": "Home",
          "settings": "Settings",
          "profile": "Profile"
        }
      },
      "actions": {
        "save": "Save",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "apply": "Apply",
        "reset": "Reset"
      }
    },
    tasks: {
      "taskPage": {
        "title": "Optimizations",
        "tabs": {
          "new": "New",
          "history": "History"
        },
        "filters": {
          "title": "Filters",
          "actionType": "Action Type",
          "dateRange": "Date Range"
        },
        "keywordActions": {
          "remove": "Keyword Removal",
          "add": "Keyword Addition",
          "pause": "Keyword Pause",
          "analyzeNegative": "Analyze Negative Keywords"
        },
        "negativeKeywords": {
          "algorithmsTitle": "Analysis Algorithms",
          "basicAlgorithm": "Basic Performance Rules",
          "advancedAlgorithm": "Advanced Performance Analysis",
          "existingTitle": "Existing Negative Keywords",
          "noExistingKeywords": "No negative keywords have been added yet.",
          "addNegative": "Add Negative",
          "addSuccess": "Negative keyword added successfully",
          "candidatesTitle": "Negative Keyword Candidates",
          "allTermsTitle": "All Search Terms",
          "noTermsFound": "No search terms data available"
        },
        "admin": {
          "toolsHeader": "Admin Optimization Tools",
          "generateButton": "Generate Optimization"
        }
      }
    }
  },
  'en-GB': {
    common: {
      "app": {
        "title": "GlitchAds",
        "menu": {
          "home": "Home",
          "settings": "Settings",
          "profile": "Profile"
        }
      },
      "actions": {
        "save": "Save",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "apply": "Apply",
        "reset": "Reset"
      }
    },
    tasks: {
      "taskPage": {
        "title": "Optimisations",
        "tabs": {
          "new": "New",
          "history": "History"
        },
        "filters": {
          "title": "Filters",
          "actionType": "Action Type",
          "dateRange": "Date Range"
        },
        "keywordActions": {
          "remove": "Keyword Removal",
          "add": "Keyword Addition",
          "pause": "Keyword Pause",
          "analyzeNegative": "Analyse Negative Keywords"
        },
        "negativeKeywords": {
          "algorithmsTitle": "Analysis Algorithms",
          "basicAlgorithm": "Basic Performance Rules",
          "advancedAlgorithm": "Advanced Performance Analysis",
          "existingTitle": "Existing Negative Keywords",
          "noExistingKeywords": "No negative keywords have been added yet.",
          "addNegative": "Add Negative",
          "addSuccess": "Negative keyword added successfully",
          "candidatesTitle": "Negative Keyword Candidates",
          "allTermsTitle": "All Search Terms",
          "noTermsFound": "No search terms data available"
        },
        "admin": {
          "toolsHeader": "Admin Optimisation Tools",
          "generateButton": "Generate Optimisation"
        }
      }
    }
  }
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources,
    fallbackLng: 'en-US',
    debug: import.meta.env.DEV,
    
    // Split translations into namespaces
    ns: ['common', 'tasks'],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false, // React already safeguards against XSS
    },
    
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'locale',
      lookupCookie: 'i18n_locale',
      lookupLocalStorage: 'i18n_locale',
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;